
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-records-ui',
  currentProjectVersion: 'static-1.78149',
  depVersions: {
  "crm-records-ui": "static-1.78149",
  "ably": "static-2.2",
  "ably-hubspot-js": "static-2.3470",
  "ai-components-ui-library": "static-1.5370",
  "apollo-dlb": "static-3.41",
  "apollo-link-hub-http": "static-2.3665",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.3845",
  "call-widget-addon": "static-2.28631",
  "calling-global-api": "static-1.58524",
  "calling-internal-common": "static-1.30132",
  "calling-lifecycle-internal": "static-1.59906",
  "card-associated-objects-lib": "static-1.39279",
  "card-associated-objects-lib-legacy": "static-1.6946",
  "card-linked-in-sales-navigator-lib": "static-1.36624",
  "card-preview-highlight-lib": "static-1.71223",
  "card-properties-lib": "static-1.39379",
  "client-types": "static-1.376",
  "commerce-contract-lib": "static-1.6938",
  "copilot-toolkit": "static-1.6844",
  "crm_data": "static-4.87208",
  "crm_ui": "static-5.87166",
  "crm-activity-creator-data": "static-1.41719",
  "crm-activity-creator-interactions-legacy": "static-1.31641",
  "crm-activity-creator-widgets": "static-1.47223",
  "crm-cards": "static-1.39968",
  "crm-cards-sdk": "static-1.38671",
  "crm-cards-test-utils": "static-1.38518",
  "crm-command-handler": "static-1.31473",
  "crm-common-dlb": "static-1.4201",
  "crm-events-data": "static-1.56318",
  "crm-fe-perf": "static-1.21898",
  "crm-legacy-global-containers": "static-1.22693",
  "crm-links": "static-1.5001",
  "crm-message-bus": "static-1.37405",
  "crm-object-map": "static-1.2212",
  "crm-pipeline-approvals-lib": "static-1.19683",
  "crm-timeline": "static-1.84643",
  "crm-timeline-tasks": "static-1.33023",
  "customer-data-communicator": "static-1.40768",
  "customer-data-email": "static-1.15916",
  "customer-data-objects": "static-1.6521",
  "customer-data-properties-shared-msw-handlers": "static-1.6505",
  "customer-data-sidebar": "static-2.41587",
  "customer-data-tracking": "static-1.5728",
  "data-fetching-client": "static-1.8521",
  "dispatcher": "static-1.113",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.306",
  "feedback-loader": "static-1.26715",
  "foundations-components": "static-1.6110",
  "foundations-theming-specialty": "static-1.929",
  "framework-data-schema-quick-fetch": "static-1.5669",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7261",
  "framework-data-table": "static-2.8862",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4043",
  "highcharts": "static-8.81",
  "history": "static-4.47",
  "hs-test-utils": "static-1.6906",
  "hub-http": "static-1.4807",
  "hubspot-apollo-client": "static-1.3722",
  "hubspot-dlb": "static-2.1406",
  "HubStyleTokens": "static-2.10404",
  "I18n": "static-7.1394",
  "immutable": "static-2.19",
  "jasmine-console-invariants": "static-1.1621",
  "jasmine-immutable": "static-1.1860",
  "jasmine-runner": "static-1.5305",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.5887",
  "MeetingsLib": "static-2.53806",
  "msw": "static-1.39",
  "multi-currency-client-types": "static-1.2853",
  "onboarding-tours": "static-1.14525",
  "PortalIdParser": "static-2.284",
  "quartz": "static-1.5650",
  "quartz-core": "static-1.4869",
  "quick-fetch": "static-1.3061",
  "quotes-ui-lib": "static-1.74995",
  "raven": "static-3.4818",
  "react": "static-7.151",
  "react-dlb": "static-1.54",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-dom": "static-7.85",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.4404",
  "recording-review-components-lib": "static-1.27346",
  "reference-resolvers": "static-1.7056",
  "reporting-data": "static-1.62210",
  "reporting-dlb": "static-1.55128",
  "reporting-testing-lib": "static-1.4145",
  "reporting-visualizations": "static-1.54287",
  "sales-clients-common": "static-1.46331",
  "settings-ui-lib": "static-1.11437",
  "tinymce": "static-6.5",
  "ui-addon-avatars": "static-2.8157",
  "ui-addon-draggable": "static-2.1200",
  "ui-addon-opt": "static-4.7517",
  "UIComponents": "static-3.7351",
  "universal-associations-select": "static-1.9701",
  "usage-based-billing-components-lib": "static-1.4329",
  "usage-tracker": "static-1.6369",
  "usage-tracker-core": "static-1.6219",
  "webpack-env": "static-1.54",
  "ai-catchup-cards-lib": "static-1.3439",
  "BizOpsCrmUIComponents": "static-1.41429",
  "call-timeline-event": "static-1.51826",
  "calling-error-reporting": "static-1.30138",
  "calling-integration-timeline-event": "static-1.14165",
  "calling-orchestration-shared-library": "static-1.30598",
  "calling-ui-library": "static-1.65824",
  "card-deal-collaborators-lib": "static-1.33450",
  "card-object-highlight-lib": "static-1.2684",
  "chatspot-widget-iframe": "static-1.16124",
  "commerce-billing-lib": "static-1.15243",
  "commerce-subscription-lib": "static-1.32033",
  "commerce-tools-ui-lib": "static-1.7034",
  "composer-plugins": "static-1.67215",
  "conversations-inbox-message-history": "static-1.30584",
  "conversations-message-history": "static-1.10003",
  "conversations-thread-view-crm-events": "static-1.29993",
  "crm_components": "static-3.87208",
  "crm_schema": "static-3.87246",
  "crm_universal": "static-1.20677",
  "crm-activity-creator-interaction-window": "static-1.41172",
  "crm-cards-dnd": "static-3.1059",
  "crm-cards-global-registry": "static-1.15549",
  "crm-display-components": "static-1.20714",
  "crm-extension": "static-1.36671",
  "crm-legacy-links": "static-1.72095",
  "crm-meetings-components-lib": "static-1.22164",
  "crm-realtime-lib": "static-1.48",
  "crm-object-preview": "static-1.21913",
  "crm-source-interpretation-lib": "static-1.4187",
  "crm-ui-legacy-tracking-page-view": "static-1.68226",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.520",
  "customer-data-filters": "static-1.48242",
  "customer-data-objects-ui-components": "static-1.11793",
  "customer-data-properties": "static-1.46366",
  "customer-data-property-utils": "static-1.6834",
  "customer-data-reference-ui-components": "static-1.11898",
  "customer-data-rte": "static-1.29410",
  "customer-data-ui-utilities": "static-1.8619",
  "deal-registration-ui": "static-1.30454",
  "deal-splits-cards-ui": "static-1.40244",
  "deal-splits-sidebar": "static-1.40150",
  "draft-email-branding-plugin": "static-2.20719",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.19447",
  "draft-signature-plugin": "static-1.20446",
  "email-confirm-ui": "static-2.4506",
  "EmailSignatureEditor": "static-1.21010",
  "ExportDialog": "static-6.9280",
  "ExtensionInstallHelpers": "static-1.539",
  "file-manager-components": "static-1.19060",
  "FileManagerLib": "static-1.34701",
  "flywheel-feedback-panel-components": "static-1.6185",
  "foundations-assets": "static-1.3814",
  "foundations-theming": "static-1.3212",
  "framework-data-schema-resolvers": "static-1.5764",
  "hubspot-prosemirror": "static-1.14110",
  "HubStyle": "static-2.10712",
  "icons": "static-2.592",
  "in-meeting-experience-ui-components": "static-1.17760",
  "InboxConnectUtils": "static-4.10284",
  "integration-settings-components": "static-1.10856",
  "lead-tracking-lib": "static-1.34718",
  "metrics-js": "static-1.8459",
  "mobile-manifest-mixins": "static-1.351",
  "native-integrations-shared-strings": "static-1.6726",
  "nav-meta": "static-1.25726",
  "object-builder-ui-client": "static-1.42925",
  "partner-shared-view-ui": "static-1.43007",
  "playbooks-modal": "static-1.75882",
  "playlists-lib": "static-1.7034",
  "products-ui-components": "static-1.35863",
  "property-history-panel": "static-1.19565",
  "property-management-iframe": "static-1.8692",
  "property-translator": "static-1.4303",
  "react-colorpicker": "static-2.9153",
  "react-immutable-proptypes": "static-2.8",
  "react-rhumb": "static-1.15473",
  "react-select-plus": "static-1.65",
  "reference-resolvers-lite": "static-1.6896",
  "reporting-action-components": "static-1.36819",
  "reporting-enablement": "static-1.17714",
  "reporting-ui-components": "static-2.59487",
  "rich-text-lib": "static-1.17592",
  "rpc-client-utils": "static-1.3612",
  "SafeStorage": "static-1.3304",
  "SalesContentIndexUI": "static-3.7251",
  "sanitize-text": "static-1.7068",
  "segment-references-panel-lib": "static-1.50879",
  "sequences-crm-events-lib": "static-1.24220",
  "sequences-crm-lib": "static-1.24417",
  "settings-ui-nav": "static-2.8995",
  "SharedI18nStrings": "static-1.162",
  "styled-components": "static-2.64",
  "subscriptions-components": "static-1.41859",
  "timezone-utils": "static-2.4139",
  "transcript-sidebar": "static-1.63421",
  "transmute": "static-2.29",
  "ui-addon-form-validation": "static-1.9920",
  "ui-addon-i18n": "static-1.9809",
  "ui-addon-iframeable": "static-1.7790",
  "ui-addon-scriptloader": "static-1.11285",
  "ui-addon-teams": "static-1.19919",
  "ui-addon-upgrades": "static-9.16154",
  "ui-asset-management-lib": "static-1.9208",
  "ui-business-units-lib": "static-1.7788",
  "ui-extensions-remote-renderer": "static-1.13044",
  "ui-gdpr-components": "static-1.9126",
  "ui-product-approvals": "static-1.24166",
  "ui-shepherd-react": "static-3.8962",
  "ui-suspension-banners-lib": "static-1.5318",
  "usage-tracker-container": "static-1.6359",
  "usage-tracker-session-replay": "static-1.4055",
  "atom": "static-1.4087",
  "hs-lodash": "static-4.45",
  "planout": "static-5.12",
  "react-immutable-render-mixin": "static-1.9",
  "react-input-autosize": "static-2.17",
  "redux-thunk": "static-2.43",
  "sanitize": "static-1.3274",
  "hs-promise-rejection-tracking": "static-1.4356",
  "raven-hubspot": "static-1.5125",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3063",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.2526",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.1927",
  "quartz-webpack": "static-1.1874",
  "hs-promise-utils": "static-1.4432",
  "autolinker": "static-3.11",
  "chatspot-client-types": "static-1.8774",
  "chatspot-core": "static-1.16130",
  "ContentUtils": "static-1.63696",
  "foundations-theming-base": "static-1.2197",
  "hs-story-utils": "static-1.8278",
  "sassPrefix": "static-1.132",
  "ui-fonts": "static-1.332",
  "ui-images": "static-2.868",
  "graphql": "static-1.59",
  "calling-client-interface": "static-1.71063",
  "calling-cross-tab-library": "static-1.18107",
  "calling-integration-cross-tab": "static-1.18239",
  "calling-integration-sdk-support": "static-1.26465",
  "calling-lifecycle-messages": "static-1.52201",
  "calling-lifecycle-usage-tracker": "static-1.5052",
  "calling-usage-tracker": "static-1.5391",
  "content-assistance-lib": "static-1.6427",
  "conversations-async-data": "static-2.6557",
  "conversations-prop-types": "static-1.6335",
  "conversations-skeleton-state": "static-1.6280",
  "customer-data-content": "static-1.24697",
  "immer": "static-1.33",
  "PatternValidationJS": "static-1.437",
  "self-service-api": "static-1.9103",
  "shared-worker-versioning": "static-1.9968",
  "onboarding-scopes": "static-1.5459",
  "frontend-preferences-client": "static-1.6781",
  "avatar-components": "static-1.1360",
  "campaigns-lib": "static-1.22741",
  "card-payment-highlight-lib": "static-1.32472",
  "commerce-subscription-cards-lib": "static-1.26857",
  "credit-memos-iframe-lib": "static-1.6915",
  "crm-pipelines-api-client-types": "static-1.3192",
  "growth-payments-core": "static-1.21506",
  "payment-link-components": "static-1.19187",
  "payments-embed-points-lib": "static-1.9796",
  "persist-promise": "static-1.2638",
  "commerce-shared-components-lib": "static-1.15050",
  "draft-content-plugins": "static-1.24773",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "FireAlarmUi": "static-1.3705",
  "inbound-db-meta-service-client": "static-1.2868",
  "multi-account-crm-panel-lib": "static-1.12916",
  "portal-alert-banners-lib": "static-1.1029",
  "react-virtualized": "static-2.74",
  "reselect": "static-2.16",
  "sequences-lib": "static-1.6067",
  "superstore": "static-1.3668",
  "ui-partner-confirmation-links-components": "static-1.22628",
  "enrichment-properties-lib": "static-1.10482",
  "inbound-db-properties-service-client": "static-1.3012",
  "utility-belt": "static-1.1458",
  "zustand": "static-1.51",
  "crm-events-components": "static-1.56304",
  "hub-http-contrib": "static-1.2054",
  "prosemirror": "static-1.13",
  "react-dnd-compat": "static-1.3557",
  "task-forms-lib": "static-1.36643",
  "task-queues": "static-1.29626",
  "ui-addon-video-player": "static-1.7678",
  "location-customization-utils-lib": "static-1.4459",
  "react-grid-layout": "static-3.35",
  "crm-actions": "static-1.4975",
  "redux-toolkit": "static-1.7",
  "customer-data-sidebar-test-utils": "static-1.36265",
  "all-properties-panel-lib": "static-1.3438",
  "card-company-summary-lib": "static-1.14681",
  "card-engagement-attachments-lib": "static-1.68633",
  "card-integration-card-lib": "static-1.68509",
  "crm-events-viz-core": "static-1.28884",
  "crm-events-viz-timeline": "static-1.36547",
  "crm-record-access-management-lib": "static-1.22159",
  "customer-data-filters-ui": "static-1.34427",
  "customer-data-modals": "static-1.3748",
  "framework-scoring-history-panel-lib": "static-1.10677",
  "invoices-iframe-lib": "static-1.52074",
  "merge-modal-lib": "static-1.7370",
  "panel-deal-registration-ai-summary-lib": "static-1.22985",
  "predictive-scores-panel": "static-1.25569",
  "property-description-translator": "static-1.2755",
  "prospecting-agent-lib": "static-1.7991",
  "redux-mock-store": "static-1.8",
  "crm-index-visualization-object-layout": "static-1.1077",
  "crm-object-search-query-utilities": "static-1.6541",
  "collaboration-sidebar": "static-1.53096",
  "outpost": "static-1.3252",
  "pipeline-validation-client-types": "static-1.2970",
  "user-context": "static-1.4082",
  "accounting-extension-card-ui": "static-1.32107",
  "ai-addon-copilot-preview": "static-1.4582",
  "analytics_js": "static-1.3424",
  "attribution-sidebar-cards": "static-1.39484",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.18104",
  "crm-events": "static-1.56311",
  "feedback-schema": "static-1.49511",
  "FileManagerCore": "static-1.34560",
  "flux-actions": "static-1.276",
  "flywheel-lead-visibility-lib": "static-1.1878",
  "forms-utils-lib": "static-1.10378",
  "FormsCommonComponents": "static-1.81552",
  "FormUrlGenerator": "static-2.3617",
  "getting-started-shared-tasks": "static-1.13230",
  "integrations-lib": "static-1.11049",
  "integrations-tracking-lib": "static-1.4421",
  "MeetingsBase": "static-1.55398",
  "partner-poi-timeline-event": "static-1.35650",
  "project-storage": "static-1.3587",
  "qualified-leads-embedded-lib": "static-1.43110",
  "quotes-crm-events-lib": "static-1.38368",
  "quotes-modal-lib": "static-1.96952",
  "react-table": "static-1.15",
  "report-customization-components": "static-1.9229",
  "reporting-snowflake": "static-1.50831",
  "salesforce-sync-card-ui": "static-1.7874",
  "salesImages": "static-1.501",
  "sequences-client-types-lib": "static-1.5924",
  "share-transcript-modal": "static-1.53066",
  "social-components-lib": "static-1.29158",
  "StyleGuideUI": "static-3.464",
  "svh-tickets-lib": "static-1.14456",
  "ui-addon-integrations-directory-panel": "static-2.6911",
  "ui-addon-react-router-dom": "static-1.8506",
  "ui-addon-sales-email": "static-1.4101",
  "ui-tour-react": "static-1.10873",
  "urlinator": "static-1.3446",
  "hubspot-prosemirror-plugins": "static-1.14102",
  "outreach-assistant-email-generation": "static-1.3223",
  "quotes-client-types": "static-1.32364",
  "sales-email-signature-service-client": "static-1.2869",
  "conditional-properties-service-client": "static-1.2998",
  "external-options-client-types": "static-1.3187",
  "inbounddb-objects-service-types": "static-1.3284",
  "card-subscription-highlight-lib": "static-1.34456",
  "invoices-highlight-card-lib": "static-1.50000",
  "orders-highlight-card-lib": "static-1.17612",
  "products-highlight-card-lib": "static-1.13628",
  "quotes-highlight-card-lib": "static-1.66281",
  "wootric-nps": "static-1.5808",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.2379",
  "floating-ui": "static-1.29",
  "framer-motion": "static-1.41",
  "react-aria": "static-1.39",
  "tanstack-table": "static-1.23",
  "framework-builder-read-service-client": "static-1.3133",
  "customer-data-associations": "static-1.6104",
  "smart-property-lib": "static-1.1362",
  "testing-library": "static-1.121",
  "HeadJS": "static-2.580",
  "hs-test-utils-bend-plugin": "static-1.2017",
  "i18n-data": "static-1.198",
  "moment-timezone": "static-5.51",
  "jasmine": "static-4.3241",
  "foundations-components-test-utils": "static-1.3595",
  "laboratory-lib": "static-3.6140",
  "react-transition-group": "static-1.7",
  "redux-actions": "static-3.7",
  "signup-constants": "static-1.16478",
  "signup-ui-lego-core": "static-1.18488",
  "signup-ui-url-generator": "static-2.6958",
  "underscore": "static-1.8",
  "usage-tracker-anonymous": "static-1.4786",
  "usage-tracker-multi": "static-1.4783",
  "usage-tracker-public": "static-1.6180",
  "viral-links-lib": "static-1.5783",
  "ts-schema": "static-1.3213",
  "growth-data-modal": "static-1.4126",
  "growth-onboarding-confetti": "static-1.1989",
  "growth-onboarding-next-action-utils": "static-1.89",
  "navigation-components": "static-1.14089",
  "ui-shepherd-tracker": "static-1.6343",
  "ui-universal-auth": "static-1.7704",
  "quartz-core-utils": "static-1.2517",
  "hub-http-janus": "static-1.652",
  "hub-http-shared-msw-handlers": "static-1.7177",
  "hubspotter-http": "static-1.3655",
  "hubspotter-http-shared-msw-handlers": "static-1.7175",
  "platform-navigation-bootstrap": "static-1.11320",
  "commerce-tours-lib": "static-1.3817",
  "csstype": "static-1.38",
  "call-summary": "static-1.33216",
  "object-comments-thread-lib": "static-1.6576",
  "reporting-client-types": "static-1.1969",
  "ui-coaching-tips": "static-1.23515",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.9368",
  "rxjs": "static-5.10",
  "react-flip-move": "static-1.47",
  "onboarding-tours-client": "static-1.3396",
  "subscription-experience-data-types": "static-1.11206",
  "crm-component-utils": "static-1.34964",
  "crm-properties-list": "static-1.33989",
  "activity-history-lib": "static-1.3016",
  "assisted-buying-components": "static-1.6010",
  "bet-customer-success-shared-ui": "static-1.12418",
  "company-details-components": "static-1.4824",
  "company-details-service-types": "static-1.2843",
  "final-form": "static-1.40",
  "flywheel-recent-conversions-lib": "static-1.2686",
  "industries-core": "static-1.5661",
  "payment-method-components": "static-1.5486",
  "quote-checkout-common-lib": "static-1.9891",
  "quote-checkout-service-types": "static-1.2478",
  "ui-addon-draggable-compat": "static-2.3158",
  "conversations-calling-message": "static-1.55604",
  "crm-events-viz-test-utils": "static-1.17505",
  "calling-orchestration-schema": "static-1.30823",
  "twilio-voice-sdk": "static-1.51",
  "worker-connection-library": "static-1.12634",
  "commerce-analytics-service-client": "static-1.2602",
  "cv-backend-services": "static-1.1202",
  "growth-onboarding-empty-states": "static-1.4146",
  "payments-enrollment-embed-lib": "static-1.18144",
  "payments-post-enroll-local-storage-lib": "static-1.3990",
  "qrcode-generator": "static-1.44",
  "conversations-infrastructure": "static-1.7838",
  "conversations-internal-schema": "static-1.11545",
  "conversations-error-reporting": "static-1.7839",
  "composer-data": "static-1.26122",
  "conversations-http": "static-1.3700",
  "conversations-internal-pub-sub": "static-1.14898",
  "conversations-platform": "static-1.3385",
  "conversations-thread-data": "static-1.63329",
  "zorse-crm-components-lib": "static-1.5909",
  "crm-activity-creator-interactions": "static-1.40444",
  "adobe-sign-cards-lib": "static-1.14301",
  "ai-dynamic-card": "static-1.838",
  "automation-ui-crm-card-workflows-invoker": "static-1.5937",
  "bundle-about-card": "static-1.1669",
  "bundle-items-card": "static-1.2313",
  "buyer-intent-card": "static-1.17114",
  "buying-group-card": "static-1.1431",
  "card-call-summaries-lib": "static-1.30942",
  "card-customer-spend-trends-lib": "static-1.22070",
  "card-flywheel-activity-history-lib": "static-1.3040",
  "card-flywheel-company-overview-lib": "static-1.12069",
  "card-flywheel-domain-review-history-lib": "static-1.1697",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.12069",
  "card-guest-access-management-lib": "static-1.3770",
  "card-guided-execution-activities": "static-1.5330",
  "card-knowledge-base-lib": "static-1.7489",
  "card-lead-insights": "static-1.10763",
  "card-lead-qualification-lib": "static-1.25825",
  "card-object-summary-lib": "static-1.3182",
  "card-other-tickets-lib": "static-1.15764",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.26776",
  "card-partner-client-unified-usage-score-lib": "static-1.21141",
  "card-prospecting-research-agent": "static-1.3651",
  "card-target-account-signals": "static-1.2200",
  "card-tasks-timeline-lib": "static-1.10354",
  "card-ticket-summary-lib": "static-1.12201",
  "commerce-billing-engine-lib": "static-1.2473",
  "commerce-payment-dispute-card": "static-1.897",
  "crm-associations-pivot": "static-1.34943",
  "crm-associations-table": "static-1.36813",
  "crm-attribution-report": "static-1.1267",
  "crm-clv-report": "static-1.3601",
  "crm-csat": "static-1.873",
  "crm-data-highlights": "static-1.37351",
  "crm-events-viz-cards": "static-1.36538",
  "crm-events-viz-totals": "static-1.28092",
  "crm-nps": "static-1.749",
  "crm-property-history": "static-1.12049",
  "crm-quick-actions": "static-1.13499",
  "crm-relative-timeline": "static-1.13927",
  "crm-report": "static-1.37558",
  "crm-simple-deadline": "static-1.14145",
  "crm-stage-tracker": "static-1.32522",
  "crm-statistics": "static-1.26567",
  "custom-events-card-lib": "static-1.620",
  "customer-overview-card-lib": "static-1.5461",
  "customer-success-contacts-card-lib": "static-1.14112",
  "deal-summary-components": "static-1.16929",
  "docusign-cards-lib": "static-1.23489",
  "flywheel-growth-plans-crm-card": "static-1.2905",
  "guided-actions-card": "static-1.10183",
  "guided-selling-stage-tracker-card": "static-1.7765",
  "health-score-card-lib": "static-1.17395",
  "intelligence-overview-card": "static-1.10946",
  "intelligence-overview-lib": "static-1.9174",
  "invoices-history-card-lib": "static-1.26427",
  "lead-scores-card": "static-1.13476",
  "legacy-sidebar-card-lib": "static-1.30785",
  "partner-ai-summary-crm-card": "static-1.3083",
  "payment-schedule-card-lib": "static-1.24276",
  "playbooks-card": "static-1.38592",
  "predictive-scores-card": "static-1.26567",
  "process-guide-cards": "static-1.4001",
  "products-cards-lib": "static-1.4934",
  "purchase-history-lib": "static-1.16015",
  "ui-google-drive-attachments": "static-1.2527",
  "ui-google-drive-insights": "static-1.2529",
  "content-embed-lib": "static-1.6251",
  "remote-ui": "static-1.40",
  "ui-extensions-plugin-flywheel": "static-1.9985",
  "credit-memos-highlight-card-lib": "static-1.6267",
  "deep-diff": "static-1.5",
  "commerce-products-lib": "static-1.5343",
  "google-libphonenumber": "static-1.12",
  "media-bridge-lib": "static-1.16855",
  "video-data-lib": "static-1.30070",
  "FileManagerImages": "static-1.32211",
  "bend-plugin-foundations-theming": "static-1.1695",
  "batch-promise": "static-1.480",
  "knowledge-content-types": "static-1.7757",
  "ui-addon-emoji-picker": "static-1.8844",
  "card-playbooks-lib": "static-1.58709",
  "in-meeting-experience-client-types": "static-1.14461",
  "marketplace-embed": "static-1.17246",
  "crm-record-cards-service-types": "static-1.2827",
  "ui-components-test-utils": "static-1.4542",
  "universal-page-editor-lib": "static-1.1848",
  "card-sales-activities-timeline": "static-1.34075",
  "partner-shared-messages-lib": "static-1.13803",
  "property-management-common": "static-1.978",
  "dashboard-lib": "static-1.76408",
  "share-with-third-party-component-lib": "static-1.7563",
  "data-quality-ui-library": "static-1.8614",
  "html-to-image": "static-1.30",
  "markdown-it": "static-1.6",
  "reporting-plugins": "static-1.7214",
  "reporting-reports": "static-1.61893",
  "data-token-picker": "static-1.14264",
  "sales-templates-service-types-lib": "static-1.3251",
  "account-and-billing-components": "static-1.16782",
  "growth-feature-usage-components": "static-1.4876",
  "subscriptions-client": "static-1.42101",
  "magpie-lib": "static-1.4557",
  "navigation-messaging": "static-1.3416",
  "feature-store-service-types": "static-1.3591",
  "growth-monetization-service-types": "static-1.3598",
  "upgrade-management-service-types": "static-1.3582",
  "ui-extensibility-client-types": "static-1.3054",
  "amplitude-session-replay-browser": "static-1.33",
  "cms-field-types": "static-1.3685",
  "content-icons-ui": "static-1.1930",
  "attribution-lib": "static-1.38141",
  "campaigns-build-lib": "static-1.8607",
  "marketing-platform-lib": "static-1.5589",
  "credit-memos-ui-lib": "static-1.6913",
  "growth-onboarding-reliability": "static-1.4051",
  "sales-checkout-service-client": "static-1.2614",
  "breeze-intelligence-kit": "static-1.4147",
  "fsm": "static-1.2627",
  "policy-lib": "static-1.5672",
  "customer-data-filters-ui-msw-helpers": "static-1.16860",
  "automation-ui-core": "static-2.16570",
  "automation-ui-permissions": "static-1.14930",
  "framework-scoring-client-types": "static-1.11730",
  "invoices-ui-lib": "static-1.50016",
  "predictive-scores-lib-components": "static-1.23964",
  "magpie-types": "static-1.4017",
  "simple-logging-lib": "static-1.1933",
  "getting-started-shared-tasks-store": "static-1.12348",
  "ai-settings-ui-library": "static-1.6031",
  "crm-pipeline-events-ui": "static-1.23806",
  "audio-components": "static-1.4565",
  "video-components": "static-1.8420",
  "video-embed": "static-1.30909",
  "flywheel-reject-ql-lib": "static-1.2707",
  "portal-details-components": "static-1.14749",
  "forms-ai-lib": "static-1.2354",
  "react-tinymce": "static-1.51061",
  "SharedLegalStrings": "static-1.1313",
  "tinymce-config": "static-2.50187",
  "integrations-error-boundary-lib": "static-1.8464",
  "meetings-client-types": "static-1.2829",
  "reporting-datasets-permissions-lib": "static-1.8250",
  "data-model-commons-lib": "static-1.7732",
  "growth-onboarding-feedback-components": "static-1.5358",
  "messaging-types-lib": "static-1.40969",
  "accounting-integrations-ui-components": "static-1.5041",
  "products-iframe-lib": "static-1.3627",
  "products-ui-components-shared-msw-handlers": "static-1.7560",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.7323",
  "emoji-regex": "static-1.7",
  "idb-keyval": "static-1.21",
  "platform-infra-nav-components": "static-1.6775",
  "fintech-buying-service-clients": "static-1.2492",
  "storybook-react": "static-1.4",
  "account-and-billing-contacts-usage": "static-2.18240",
  "signup-ui-full-screen-search": "static-1.10262",
  "billing-payments-client-types": "static-1.2880",
  "buying-experience-components": "static-1.8749",
  "checkout-service-types": "static-1.2987",
  "growth-pro-utils-lib": "static-1.9274",
  "trellis-story-utils": "static-1.3454",
  "marketplace-ui-apps-core": "static-1.13367",
  "stripe-embedded-components": "static-1.5399",
  "conversations-routing-lib": "static-1.7020",
  "immutable-less": "static-1.3443",
  "routing-ui": "static-1.16717",
  "codemirror": "static-5.72",
  "react-codemirror": "static-1.9509",
  "automation-enrollment-service-types": "static-1.2779",
  "automation-platform-service-types": "static-1.2182",
  "automation-ui-ubb": "static-1.553",
  "commerce-products-api": "static-1.311",
  "buyer-intent-lib": "static-1.1657",
  "domain-review-history-lib": "static-1.3095",
  "renewal-center-service-types": "static-1.3062",
  "recent-activities-card": "static-1.54168",
  "submissions-lib": "static-1.42343",
  "ui-forms-components": "static-1.8373",
  "customer-success-client-types": "static-1.15405",
  "sales-enablement-lib": "static-1.12997",
  "sales-leader-insights-components-lib": "static-1.14261",
  "guided-actions-lib": "static-1.15534",
  "schedule-lib": "static-1.10981",
  "framework-scoring-components-lib": "static-1.12140",
  "card-bet-associated-companies-lib": "static-1.72341",
  "card-bet-deal-support-requests-lib": "static-1.63082",
  "card-bet-quotes-lib": "static-1.72348",
  "card-biz-ops-customer-success-lib": "static-1.72362",
  "card-biz-ops-domain-controls-lib": "static-1.72363",
  "card-biz-ops-related-contacts-lib": "static-1.72362",
  "card-crm-attribution-lib": "static-1.50751",
  "card-customer-success-lib": "static-1.606",
  "card-deal-shared-view-lib": "static-1.64049",
  "card-deal-splits-lib": "static-1.39630",
  "card-flywheel-ql-summary-lib": "static-1.41228",
  "card-flywheel-recent-conversions-lib": "static-1.41229",
  "card-gdpr-subscriptions-card-lib": "static-1.42561",
  "card-invoices-lib": "static-1.51865",
  "card-lists-lib": "static-1.66821",
  "card-marketing-event-about-lib": "static-1.51647",
  "card-marketing-event-activity-lib": "static-1.51646",
  "card-past-conversations-lib": "static-1.32758",
  "card-past-feedback-lib": "static-1.37436",
  "card-payment-history-lib": "static-1.32336",
  "card-profile-products-lib": "static-1.52607",
  "card-profile-quotes-lib": "static-1.79799",
  "card-prospecting-notes": "static-1.34075",
  "card-qualified-leads-lib": "static-1.72503",
  "card-sfdcsync-lib": "static-1.51717",
  "card-target-account-lib": "static-1.68429",
  "card-website-activity-lib": "static-1.69164",
  "card-workflows-lib": "static-1.68582",
  "integrations-sync-card-ui": "static-1.22643",
  "invoices-card-lib": "static-1.52143",
  "marketing-event-cards-ui": "static-1.32621",
  "orders-card-lib": "static-1.17329",
  "partner-poi-crm-card": "static-1.15617",
  "recording-preview-card": "static-1.12695",
  "surveymonkey-crm-card": "static-1.36136",
  "ui-sales-order-wizard-card": "static-1.27640",
  "sales-execution-components": "static-1.9059",
  "process-guide-chirp": "static-1.3833",
  "gapi-client-types": "static-1.5",
  "google-picker-types": "static-1.5",
  "ui-google-drive-commons": "static-1.663",
  "ui-google-drive-picker": "static-1.2098",
  "marketplace-ui-client-types": "static-1.12238",
  "marketplace-ui-common": "static-1.14831",
  "marketplace-ui-details": "static-1.4731",
  "trellis-ecosystem": "static-1.4847",
  "campaign-roi-lib": "static-1.3679",
  "account-and-billing-fintech-outages": "static-3.15532",
  "fintech-outages-service-client-types": "static-1.12503",
  "transactions-exp-service-client-types": "static-1.12499",
  "growth-feature-usage-data": "static-1.5095",
  "automation-ui-routing": "static-1.15994",
  "automation-ui-source-apps": "static-1.13716",
  "immerable": "static-1.3045",
  "social-insights-client-types": "static-1.18063",
  "user-configuration-lib": "static-1.25577",
  "tinymce-themes": "static-1.52157",
  "interframe": "static-3.3688",
  "tinymce-data": "static-1.36272",
  "tinymce-plugins": "static-1.53301",
  "ContentData": "static-1.63772",
  "marketing-email-service-types": "static-1.1464",
  "sales-views-client-types": "static-1.3212",
  "ui-signature-editor": "static-1.14200",
  "developer-experience-shared-components": "static-1.9096",
  "stripe-connect-js": "static-1.40",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "automation-ui-usage-tracking": "static-1.16036",
  "form-builder-ui": "static-1.8010",
  "ui-deal-management-components-lib": "static-1.15957",
  "ai-rendering-library": "static-1.5591",
  "calendar-integration-client-types": "static-1.2628",
  "calendar-integration-events-lib": "static-1.4698",
  "crm-index-associations-lib": "static-1.5309",
  "react-window": "static-1.13",
  "ai-studio-lib": "static-1.6291",
  "embedded-academy-lib": "static-1.10520",
  "marketplace-ui-reviews": "static-1.14790",
  "marketplace-ui-tracking": "static-1.9005",
  "app-users-service-client": "static-1.4078",
  "app-users-service-types": "static-1.3486",
  "framework-listing-lib": "static-2.23281",
  "mini-checkout-client": "static-1.24466",
  "onboarding-utils": "static-1.4251",
  "ui-coaching-tips-shared-config": "static-1.23500",
  "NamespacedHubStyle": "static-2.8303",
  "layout-dnd-components": "static-1.10831",
  "layout-dnd-utils": "static-1.9806",
  "ui-brand-identity-lib": "static-1.9282",
  "apps-service-types": "static-1.2980",
  "oauth-service-types": "static-1.3193",
  "automation-ui-types": "static-1.14634",
  "highlight.js": "static-1.45",
  "automation-ui-action-features": "static-1.50313",
  "academy-common-lib": "static-1.9980",
  "customer-data-views-management": "static-1.22571",
  "touchless-buying-components": "static-1.3502",
  "merchandise-lib": "static-1.223",
  "settings-content-modals": "static-1.40892",
  "layout-data-lib": "static-1.8131",
  "ads-client-types": "static-1.17574",
  "automation-actions-service-types": "static-1.3388",
  "automation-applications-service-types": "static-1.2622",
  "automation-ui-action-fields": "static-1.33690",
  "automation-ui-associations": "static-1.15244",
  "automation-ui-enrollment": "static-1.51975",
  "automation-ui-flow-core": "static-1.15959",
  "automation-ui-formula-editor": "static-1.12076",
  "automation-ui-i18n": "static-1.16027",
  "automation-ui-references": "static-1.15982",
  "crm-properties-common-lib": "static-1.4565",
  "data-token-views": "static-1.14245",
  "fuzzy": "static-1.8",
  "messaging-editing-lib": "static-1.41233",
  "skills-lib": "static-1.25493",
  "ui-addon-automation-embed": "static-1.12467",
  "academy-service-client": "static-1.2688",
  "crm-export-dialog": "static-1.5185",
  "react-beautiful-dnd": "static-1.13",
  "checkout-sdk": "static-3.21309",
  "pricing-pages-ui-components": "static-1.8427",
  "upgrade-catalog-service-types": "static-1.2711",
  "access-control-lib": "static-1.9351",
  "EmailComponents": "static-1.49786",
  "EmailData": "static-1.48462",
  "redux-less": "static-2.8348",
  "crm-association-components-lib": "static-1.5322",
  "messaging-publishing-lib": "static-1.41185",
  "mobile-messaging-management-lib": "static-1.29904",
  "data-ops-fullstory": "static-1.4227",
  "workflows-copilot-service-types": "static-1.1562",
  "ContentEditorUI": "static-2.72328",
  "short-messages-app-service-client": "static-1.2974",
  "ui-tool-access": "static-1.8969",
  "web-interactives-components": "static-1.11659",
  "web-interactives-data": "static-1.11660",
  "conversations-thread-view": "static-1.72060",
  "conversations-visibility-tools": "static-1.4663",
  "hub-http-rxjs": "static-1.619",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "pricing-pages-api": "static-1.8289",
  "ContentComponents": "static-2.66653",
  "marketing-contacts-lib": "static-1.8041",
  "messaging-management-lib": "static-1.12745",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3977",
  "copilot-plugins": "static-1.6817",
  "cta-picker": "static-1.32084",
  "editor-components": "static-1.11922",
  "editor-iframe-lib": "static-1.7215",
  "error-messaging-js": "static-1.4194",
  "pictos": "static-7.161",
  "redux-request-state": "static-1.9488",
  "smart-content-core": "static-1.37950",
  "smart-content-lib": "static-1.38603",
  "social-composer-lib": "static-1.53880",
  "structured-content-lib": "static-1.20848",
  "theme-previewer-lib": "static-1.48706",
  "tinymce-copilot": "static-1.12255",
  "ui-active-theme-content-creator-lib": "static-1.32891",
  "ui-memberships-settings-lib": "static-1.29116",
  "xray-recommendation-lib": "static-1.6120",
  "calling-integration-help-desk": "static-1.20045",
  "demographics-service-types": "static-1.748",
  "eligibility-engine-service-types": "static-1.2280",
  "personalization-service-types": "static-1.2101",
  "trials-service-types": "static-1.2999",
  "simple-menus-core": "static-1.13674",
  "simple-menus-lib": "static-1.15191",
  "videoconference-integration-components": "static-1.5077",
  "jquery": "static-3.6",
  "codemirror-dlb": "static-1.53884",
  "redux-undo": "static-1.10",
  "seamless-immutable": "static-7.6"
},
  depPathPrefixes: {
  "crm-records-ui": "/crm-records-ui/static-1.78149",
  "ably": "/ably/static-2.2",
  "ably-hubspot-js": "/ably-hubspot-js/static-2.3470",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.5370",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3665",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.3845",
  "call-widget-addon": "/call-widget-addon/static-2.28631",
  "calling-global-api": "/calling-global-api/static-1.58524",
  "calling-internal-common": "/calling-internal-common/static-1.30132",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.59906",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.39279",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.6946",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.36624",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.71223",
  "card-properties-lib": "/card-properties-lib/static-1.39379",
  "client-types": "/client-types/static-1.376",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.6938",
  "copilot-toolkit": "/copilot-toolkit/static-1.6844",
  "crm_data": "/crm_data/static-4.87208",
  "crm_ui": "/crm_ui/static-5.87166",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.41719",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.31641",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.47223",
  "crm-cards": "/crm-cards/static-1.39968",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.38671",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.38518",
  "crm-command-handler": "/crm-command-handler/static-1.31473",
  "crm-common-dlb": "/crm-common-dlb/static-1.4201",
  "crm-events-data": "/crm-events-data/static-1.56318",
  "crm-fe-perf": "/crm-fe-perf/static-1.21898",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22693",
  "crm-links": "/crm-links/static-1.5001",
  "crm-message-bus": "/crm-message-bus/static-1.37405",
  "crm-object-map": "/crm-object-map/static-1.2212",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.19683",
  "crm-timeline": "/crm-timeline/static-1.84643",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.33023",
  "customer-data-communicator": "/customer-data-communicator/static-1.40768",
  "customer-data-email": "/customer-data-email/static-1.15916",
  "customer-data-objects": "/customer-data-objects/static-1.6521",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6505",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.41587",
  "customer-data-tracking": "/customer-data-tracking/static-1.5728",
  "data-fetching-client": "/data-fetching-client/static-1.8521",
  "dispatcher": "/dispatcher/static-1.113",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.306",
  "feedback-loader": "/feedback-loader/static-1.26715",
  "foundations-components": "/foundations-components/static-1.6110",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.929",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5669",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7261",
  "framework-data-table": "/framework-data-table/static-2.8862",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4043",
  "highcharts": "/highcharts/static-8.81",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.6906",
  "hub-http": "/hub-http/static-1.4807",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3722",
  "hubspot-dlb": "/hubspot-dlb/static-2.1406",
  "HubStyleTokens": "/HubStyleTokens/static-2.10404",
  "I18n": "/I18n/static-7.1394",
  "immutable": "/immutable/static-2.19",
  "jasmine-console-invariants": "/jasmine-console-invariants/static-1.1621",
  "jasmine-immutable": "/jasmine-immutable/static-1.1860",
  "jasmine-runner": "/jasmine-runner/static-1.5305",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.5887",
  "MeetingsLib": "/MeetingsLib/static-2.53806",
  "msw": "/msw/static-1.39",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2853",
  "onboarding-tours": "/onboarding-tours/static-1.14525",
  "PortalIdParser": "/PortalIdParser/static-2.284",
  "quartz": "/quartz/static-1.5650",
  "quartz-core": "/quartz-core/static-1.4869",
  "quick-fetch": "/quick-fetch/static-1.3061",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.74995",
  "raven": "/raven/static-3.4818",
  "react": "/react/static-7.151",
  "react-dlb": "/react-dlb/static-1.54",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-dom": "/react-dom/static-7.85",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.4404",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.27346",
  "reference-resolvers": "/reference-resolvers/static-1.7056",
  "reporting-data": "/reporting-data/static-1.62210",
  "reporting-dlb": "/reporting-dlb/static-1.55128",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.4145",
  "reporting-visualizations": "/reporting-visualizations/static-1.54287",
  "sales-clients-common": "/sales-clients-common/static-1.46331",
  "settings-ui-lib": "/settings-ui-lib/static-1.11437",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1200",
  "ui-addon-opt": "/ui-addon-opt/static-4.7517",
  "UIComponents": "/UIComponents/static-3.7351",
  "universal-associations-select": "/universal-associations-select/static-1.9701",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.4329",
  "usage-tracker": "/usage-tracker/static-1.6369",
  "usage-tracker-core": "/usage-tracker-core/static-1.6219",
  "webpack-env": "/webpack-env/static-1.54",
  "ai-catchup-cards-lib": "/ai-catchup-cards-lib/static-1.3439",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.41429",
  "call-timeline-event": "/call-timeline-event/static-1.51826",
  "calling-error-reporting": "/calling-error-reporting/static-1.30138",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.14165",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30598",
  "calling-ui-library": "/calling-ui-library/static-1.65824",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.33450",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.2684",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.16124",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.15243",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.32033",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.7034",
  "composer-plugins": "/composer-plugins/static-1.67215",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.30584",
  "conversations-message-history": "/conversations-message-history/static-1.10003",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.29993",
  "crm_components": "/crm_components/static-3.87208",
  "crm_schema": "/crm_schema/static-3.87246",
  "crm_universal": "/crm_universal/static-1.20677",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.41172",
  "crm-cards-dnd": "/crm-cards-dnd/static-3.1059",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.15549",
  "crm-display-components": "/crm-display-components/static-1.20714",
  "crm-extension": "/crm-extension/static-1.36671",
  "crm-legacy-links": "/crm-legacy-links/static-1.72095",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.22164",
  "crm-realtime-lib": "/crm-realtime-lib/static-1.48",
  "crm-object-preview": "/crm-object-preview/static-1.21913",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4187",
  "crm-ui-legacy-tracking-page-view": "/crm-ui-legacy-tracking-page-view/static-1.68226",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.520",
  "customer-data-filters": "/customer-data-filters/static-1.48242",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11793",
  "customer-data-properties": "/customer-data-properties/static-1.46366",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6834",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11898",
  "customer-data-rte": "/customer-data-rte/static-1.29410",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8619",
  "deal-registration-ui": "/deal-registration-ui/static-1.30454",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.40244",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.40150",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.20719",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.19447",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.20446",
  "email-confirm-ui": "/email-confirm-ui/static-2.4506",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.21010",
  "ExportDialog": "/ExportDialog/static-6.9280",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.539",
  "file-manager-components": "/file-manager-components/static-1.19060",
  "FileManagerLib": "/FileManagerLib/static-1.34701",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.6185",
  "foundations-assets": "/foundations-assets/static-1.3814",
  "foundations-theming": "/foundations-theming/static-1.3212",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5764",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.14110",
  "HubStyle": "/HubStyle/static-2.10712",
  "icons": "/icons/static-2.592",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.17760",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.10284",
  "integration-settings-components": "/integration-settings-components/static-1.10856",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.34718",
  "metrics-js": "/metrics-js/static-1.8459",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.351",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6726",
  "nav-meta": "/nav-meta/static-1.25726",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.42925",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.43007",
  "playbooks-modal": "/playbooks-modal/static-1.75882",
  "playlists-lib": "/playlists-lib/static-1.7034",
  "products-ui-components": "/products-ui-components/static-1.35863",
  "property-history-panel": "/property-history-panel/static-1.19565",
  "property-management-iframe": "/property-management-iframe/static-1.8692",
  "property-translator": "/property-translator/static-1.4303",
  "react-colorpicker": "/react-colorpicker/static-2.9153",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-rhumb": "/react-rhumb/static-1.15473",
  "react-select-plus": "/react-select-plus/static-1.65",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6896",
  "reporting-action-components": "/reporting-action-components/static-1.36819",
  "reporting-enablement": "/reporting-enablement/static-1.17714",
  "reporting-ui-components": "/reporting-ui-components/static-2.59487",
  "rich-text-lib": "/rich-text-lib/static-1.17592",
  "rpc-client-utils": "/rpc-client-utils/static-1.3612",
  "SafeStorage": "/SafeStorage/static-1.3304",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.7251",
  "sanitize-text": "/sanitize-text/static-1.7068",
  "segment-references-panel-lib": "/segment-references-panel-lib/static-1.50879",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.24220",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.24417",
  "settings-ui-nav": "/settings-ui-nav/static-2.8995",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
  "styled-components": "/styled-components/static-2.64",
  "subscriptions-components": "/subscriptions-components/static-1.41859",
  "timezone-utils": "/timezone-utils/static-2.4139",
  "transcript-sidebar": "/transcript-sidebar/static-1.63421",
  "transmute": "/transmute/static-2.29",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9920",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9809",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7790",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.11285",
  "ui-addon-teams": "/ui-addon-teams/static-1.19919",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16154",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9208",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7788",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.13044",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.9126",
  "ui-product-approvals": "/ui-product-approvals/static-1.24166",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8962",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5318",
  "usage-tracker-container": "/usage-tracker-container/static-1.6359",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4055",
  "atom": "/atom/static-1.4087",
  "hs-lodash": "/hs-lodash/static-4.45",
  "planout": "/planout/static-5.12",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sanitize": "/sanitize/static-1.3274",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
  "raven-hubspot": "/raven-hubspot/static-1.5125",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2526",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1927",
  "quartz-webpack": "/quartz-webpack/static-1.1874",
  "hs-promise-utils": "/hs-promise-utils/static-1.4432",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-client-types": "/chatspot-client-types/static-1.8774",
  "chatspot-core": "/chatspot-core/static-1.16130",
  "ContentUtils": "/ContentUtils/static-1.63696",
  "foundations-theming-base": "/foundations-theming-base/static-1.2197",
  "hs-story-utils": "/hs-story-utils/static-1.8278",
  "sassPrefix": "/sassPrefix/static-1.132",
  "ui-fonts": "/ui-fonts/static-1.332",
  "ui-images": "/ui-images/static-2.868",
  "graphql": "/graphql/static-1.59",
  "calling-client-interface": "/calling-client-interface/static-1.71063",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18107",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.18239",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.26465",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.52201",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.5052",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.5391",
  "content-assistance-lib": "/content-assistance-lib/static-1.6427",
  "conversations-async-data": "/conversations-async-data/static-2.6557",
  "conversations-prop-types": "/conversations-prop-types/static-1.6335",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6280",
  "customer-data-content": "/customer-data-content/static-1.24697",
  "immer": "/immer/static-1.33",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "self-service-api": "/self-service-api/static-1.9103",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9968",
  "onboarding-scopes": "/onboarding-scopes/static-1.5459",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6781",
  "avatar-components": "/avatar-components/static-1.1360",
  "campaigns-lib": "/campaigns-lib/static-1.22741",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.32472",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.26857",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.6915",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3192",
  "growth-payments-core": "/growth-payments-core/static-1.21506",
  "payment-link-components": "/payment-link-components/static-1.19187",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9796",
  "persist-promise": "/persist-promise/static-1.2638",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.15050",
  "draft-content-plugins": "/draft-content-plugins/static-1.24773",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "FireAlarmUi": "/FireAlarmUi/static-1.3705",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2868",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.12916",
  "portal-alert-banners-lib": "/portal-alert-banners-lib/static-1.1029",
  "react-virtualized": "/react-virtualized/static-2.74",
  "reselect": "/reselect/static-2.16",
  "sequences-lib": "/sequences-lib/static-1.6067",
  "superstore": "/superstore/static-1.3668",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.22628",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.10482",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3012",
  "utility-belt": "/utility-belt/static-1.1458",
  "zustand": "/zustand/static-1.51",
  "crm-events-components": "/crm-events-components/static-1.56304",
  "hub-http-contrib": "/hub-http-contrib/static-1.2054",
  "prosemirror": "/prosemirror/static-1.13",
  "react-dnd-compat": "/react-dnd-compat/static-1.3557",
  "task-forms-lib": "/task-forms-lib/static-1.36643",
  "task-queues": "/task-queues/static-1.29626",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7678",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4459",
  "react-grid-layout": "/react-grid-layout/static-3.35",
  "crm-actions": "/crm-actions/static-1.4975",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.36265",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.3438",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.14681",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.68633",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.68509",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.28884",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.36547",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.22159",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34427",
  "customer-data-modals": "/customer-data-modals/static-1.3748",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.10677",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.52074",
  "merge-modal-lib": "/merge-modal-lib/static-1.7370",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.22985",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.25569",
  "property-description-translator": "/property-description-translator/static-1.2755",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.7991",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.1077",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6541",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.53096",
  "outpost": "/outpost/static-1.3252",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2970",
  "user-context": "/user-context/static-1.4082",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.32107",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4582",
  "analytics_js": "/analytics_js/static-1.3424",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.39484",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.18104",
  "crm-events": "/crm-events/static-1.56311",
  "feedback-schema": "/feedback-schema/static-1.49511",
  "FileManagerCore": "/FileManagerCore/static-1.34560",
  "flux-actions": "/flux-actions/static-1.276",
  "flywheel-lead-visibility-lib": "/flywheel-lead-visibility-lib/static-1.1878",
  "forms-utils-lib": "/forms-utils-lib/static-1.10378",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.81552",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.3617",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.13230",
  "integrations-lib": "/integrations-lib/static-1.11049",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4421",
  "MeetingsBase": "/MeetingsBase/static-1.55398",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.35650",
  "project-storage": "/project-storage/static-1.3587",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.43110",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.38368",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.96952",
  "react-table": "/react-table/static-1.15",
  "report-customization-components": "/report-customization-components/static-1.9229",
  "reporting-snowflake": "/reporting-snowflake/static-1.50831",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7874",
  "salesImages": "/salesImages/static-1.501",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5924",
  "share-transcript-modal": "/share-transcript-modal/static-1.53066",
  "social-components-lib": "/social-components-lib/static-1.29158",
  "StyleGuideUI": "/StyleGuideUI/static-3.464",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.14456",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6911",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8506",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4101",
  "ui-tour-react": "/ui-tour-react/static-1.10873",
  "urlinator": "/urlinator/static-1.3446",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.14102",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.3223",
  "quotes-client-types": "/quotes-client-types/static-1.32364",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2869",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2998",
  "external-options-client-types": "/external-options-client-types/static-1.3187",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3284",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.34456",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.50000",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.17612",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.13628",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.66281",
  "wootric-nps": "/wootric-nps/static-1.5808",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2379",
  "floating-ui": "/floating-ui/static-1.29",
  "framer-motion": "/framer-motion/static-1.41",
  "react-aria": "/react-aria/static-1.39",
  "tanstack-table": "/tanstack-table/static-1.23",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3133",
  "customer-data-associations": "/customer-data-associations/static-1.6104",
  "smart-property-lib": "/smart-property-lib/static-1.1362",
  "testing-library": "/testing-library/static-1.121",
  "HeadJS": "/HeadJS/static-2.580",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2017",
  "i18n-data": "/i18n-data/static-1.198",
  "moment-timezone": "/moment-timezone/static-5.51",
  "jasmine": "/jasmine/static-4.3241",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3595",
  "laboratory-lib": "/laboratory-lib/static-3.6140",
  "react-transition-group": "/react-transition-group/static-1.7",
  "redux-actions": "/redux-actions/static-3.7",
  "signup-constants": "/signup-constants/static-1.16478",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18488",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6958",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4786",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4783",
  "usage-tracker-public": "/usage-tracker-public/static-1.6180",
  "viral-links-lib": "/viral-links-lib/static-1.5783",
  "ts-schema": "/ts-schema/static-1.3213",
  "growth-data-modal": "/growth-data-modal/static-1.4126",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1989",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.89",
  "navigation-components": "/navigation-components/static-1.14089",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6343",
  "ui-universal-auth": "/ui-universal-auth/static-1.7704",
  "quartz-core-utils": "/quartz-core-utils/static-1.2517",
  "hub-http-janus": "/hub-http-janus/static-1.652",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7177",
  "hubspotter-http": "/hubspotter-http/static-1.3655",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7175",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11320",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.3817",
  "csstype": "/csstype/static-1.38",
  "call-summary": "/call-summary/static-1.33216",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.6576",
  "reporting-client-types": "/reporting-client-types/static-1.1969",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.23515",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.9368",
  "rxjs": "/rxjs/static-5.10",
  "react-flip-move": "/react-flip-move/static-1.47",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.3396",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.11206",
  "crm-component-utils": "/crm-component-utils/static-1.34964",
  "crm-properties-list": "/crm-properties-list/static-1.33989",
  "activity-history-lib": "/activity-history-lib/static-1.3016",
  "assisted-buying-components": "/assisted-buying-components/static-1.6010",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.12418",
  "company-details-components": "/company-details-components/static-1.4824",
  "company-details-service-types": "/company-details-service-types/static-1.2843",
  "final-form": "/final-form/static-1.40",
  "flywheel-recent-conversions-lib": "/flywheel-recent-conversions-lib/static-1.2686",
  "industries-core": "/industries-core/static-1.5661",
  "payment-method-components": "/payment-method-components/static-1.5486",
  "quote-checkout-common-lib": "/quote-checkout-common-lib/static-1.9891",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.2478",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3158",
  "conversations-calling-message": "/conversations-calling-message/static-1.55604",
  "crm-events-viz-test-utils": "/crm-events-viz-test-utils/static-1.17505",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30823",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.51",
  "worker-connection-library": "/worker-connection-library/static-1.12634",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2602",
  "cv-backend-services": "/cv-backend-services/static-1.1202",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4146",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.18144",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3990",
  "qrcode-generator": "/qrcode-generator/static-1.44",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7838",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.11545",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7839",
  "composer-data": "/composer-data/static-1.26122",
  "conversations-http": "/conversations-http/static-1.3700",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14898",
  "conversations-platform": "/conversations-platform/static-1.3385",
  "conversations-thread-data": "/conversations-thread-data/static-1.63329",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5909",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.40444",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.14301",
  "ai-dynamic-card": "/ai-dynamic-card/static-1.838",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.5937",
  "bundle-about-card": "/bundle-about-card/static-1.1669",
  "bundle-items-card": "/bundle-items-card/static-1.2313",
  "buyer-intent-card": "/buyer-intent-card/static-1.17114",
  "buying-group-card": "/buying-group-card/static-1.1431",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.30942",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.22070",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.3040",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.12069",
  "card-flywheel-domain-review-history-lib": "/card-flywheel-domain-review-history-lib/static-1.1697",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.12069",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.3770",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.5330",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.7489",
  "card-lead-insights": "/card-lead-insights/static-1.10763",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.25825",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.3182",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.15764",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.26776",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.21141",
  "card-prospecting-research-agent": "/card-prospecting-research-agent/static-1.3651",
  "card-target-account-signals": "/card-target-account-signals/static-1.2200",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.10354",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.12201",
  "commerce-billing-engine-lib": "/commerce-billing-engine-lib/static-1.2473",
  "commerce-payment-dispute-card": "/commerce-payment-dispute-card/static-1.897",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.34943",
  "crm-associations-table": "/crm-associations-table/static-1.36813",
  "crm-attribution-report": "/crm-attribution-report/static-1.1267",
  "crm-clv-report": "/crm-clv-report/static-1.3601",
  "crm-csat": "/crm-csat/static-1.873",
  "crm-data-highlights": "/crm-data-highlights/static-1.37351",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.36538",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.28092",
  "crm-nps": "/crm-nps/static-1.749",
  "crm-property-history": "/crm-property-history/static-1.12049",
  "crm-quick-actions": "/crm-quick-actions/static-1.13499",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.13927",
  "crm-report": "/crm-report/static-1.37558",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.14145",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.32522",
  "crm-statistics": "/crm-statistics/static-1.26567",
  "custom-events-card-lib": "/custom-events-card-lib/static-1.620",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.5461",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.14112",
  "deal-summary-components": "/deal-summary-components/static-1.16929",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.23489",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.2905",
  "guided-actions-card": "/guided-actions-card/static-1.10183",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.7765",
  "health-score-card-lib": "/health-score-card-lib/static-1.17395",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.10946",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.9174",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.26427",
  "lead-scores-card": "/lead-scores-card/static-1.13476",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.30785",
  "partner-ai-summary-crm-card": "/partner-ai-summary-crm-card/static-1.3083",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.24276",
  "playbooks-card": "/playbooks-card/static-1.38592",
  "predictive-scores-card": "/predictive-scores-card/static-1.26567",
  "process-guide-cards": "/process-guide-cards/static-1.4001",
  "products-cards-lib": "/products-cards-lib/static-1.4934",
  "purchase-history-lib": "/purchase-history-lib/static-1.16015",
  "ui-google-drive-attachments": "/ui-google-drive-attachments/static-1.2527",
  "ui-google-drive-insights": "/ui-google-drive-insights/static-1.2529",
  "content-embed-lib": "/content-embed-lib/static-1.6251",
  "remote-ui": "/remote-ui/static-1.40",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.9985",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.6267",
  "deep-diff": "/deep-diff/static-1.5",
  "commerce-products-lib": "/commerce-products-lib/static-1.5343",
  "google-libphonenumber": "/google-libphonenumber/static-1.12",
  "media-bridge-lib": "/media-bridge-lib/static-1.16855",
  "video-data-lib": "/video-data-lib/static-1.30070",
  "FileManagerImages": "/FileManagerImages/static-1.32211",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1695",
  "batch-promise": "/batch-promise/static-1.480",
  "knowledge-content-types": "/knowledge-content-types/static-1.7757",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8844",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.58709",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.14461",
  "marketplace-embed": "/marketplace-embed/static-1.17246",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2827",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.4542",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1848",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.34075",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.13803",
  "property-management-common": "/property-management-common/static-1.978",
  "dashboard-lib": "/dashboard-lib/static-1.76408",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7563",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.8614",
  "html-to-image": "/html-to-image/static-1.30",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-plugins": "/reporting-plugins/static-1.7214",
  "reporting-reports": "/reporting-reports/static-1.61893",
  "data-token-picker": "/data-token-picker/static-1.14264",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3251",
  "account-and-billing-components": "/account-and-billing-components/static-1.16782",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.4876",
  "subscriptions-client": "/subscriptions-client/static-1.42101",
  "magpie-lib": "/magpie-lib/static-1.4557",
  "navigation-messaging": "/navigation-messaging/static-1.3416",
  "feature-store-service-types": "/feature-store-service-types/static-1.3591",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3598",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3582",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3054",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.33",
  "cms-field-types": "/cms-field-types/static-1.3685",
  "content-icons-ui": "/content-icons-ui/static-1.1930",
  "attribution-lib": "/attribution-lib/static-1.38141",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.8607",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.5589",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.6913",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4051",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2614",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4147",
  "fsm": "/fsm/static-1.2627",
  "policy-lib": "/policy-lib/static-1.5672",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16860",
  "automation-ui-core": "/automation-ui-core/static-2.16570",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.14930",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.11730",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.50016",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.23964",
  "magpie-types": "/magpie-types/static-1.4017",
  "simple-logging-lib": "/simple-logging-lib/static-1.1933",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12348",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6031",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.23806",
  "audio-components": "/audio-components/static-1.4565",
  "video-components": "/video-components/static-1.8420",
  "video-embed": "/video-embed/static-1.30909",
  "flywheel-reject-ql-lib": "/flywheel-reject-ql-lib/static-1.2707",
  "portal-details-components": "/portal-details-components/static-1.14749",
  "forms-ai-lib": "/forms-ai-lib/static-1.2354",
  "react-tinymce": "/react-tinymce/static-1.51061",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1313",
  "tinymce-config": "/tinymce-config/static-2.50187",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8464",
  "meetings-client-types": "/meetings-client-types/static-1.2829",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.8250",
  "data-model-commons-lib": "/data-model-commons-lib/static-1.7732",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5358",
  "messaging-types-lib": "/messaging-types-lib/static-1.40969",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5041",
  "products-iframe-lib": "/products-iframe-lib/static-1.3627",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7560",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7323",
  "emoji-regex": "/emoji-regex/static-1.7",
  "idb-keyval": "/idb-keyval/static-1.21",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6775",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2492",
  "storybook-react": "/storybook-react/static-1.4",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.18240",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10262",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2880",
  "buying-experience-components": "/buying-experience-components/static-1.8749",
  "checkout-service-types": "/checkout-service-types/static-1.2987",
  "growth-pro-utils-lib": "/growth-pro-utils-lib/static-1.9274",
  "trellis-story-utils": "/trellis-story-utils/static-1.3454",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.13367",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.5399",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.7020",
  "immutable-less": "/immutable-less/static-1.3443",
  "routing-ui": "/routing-ui/static-1.16717",
  "codemirror": "/codemirror/static-5.72",
  "react-codemirror": "/react-codemirror/static-1.9509",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2779",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2182",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.553",
  "commerce-products-api": "/commerce-products-api/static-1.311",
  "buyer-intent-lib": "/buyer-intent-lib/static-1.1657",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.3095",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.3062",
  "recent-activities-card": "/recent-activities-card/static-1.54168",
  "submissions-lib": "/submissions-lib/static-1.42343",
  "ui-forms-components": "/ui-forms-components/static-1.8373",
  "customer-success-client-types": "/customer-success-client-types/static-1.15405",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.12997",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.14261",
  "guided-actions-lib": "/guided-actions-lib/static-1.15534",
  "schedule-lib": "/schedule-lib/static-1.10981",
  "framework-scoring-components-lib": "/framework-scoring-components-lib/static-1.12140",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.72341",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.63082",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.72348",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.72362",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.72363",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.72362",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.50751",
  "card-customer-success-lib": "/card-customer-success-lib/static-1.606",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.64049",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.39630",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.41228",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.41229",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.42561",
  "card-invoices-lib": "/card-invoices-lib/static-1.51865",
  "card-lists-lib": "/card-lists-lib/static-1.66821",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.51647",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.51646",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.32758",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.37436",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.32336",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.52607",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.79799",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.34075",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.72503",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.51717",
  "card-target-account-lib": "/card-target-account-lib/static-1.68429",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.69164",
  "card-workflows-lib": "/card-workflows-lib/static-1.68582",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.22643",
  "invoices-card-lib": "/invoices-card-lib/static-1.52143",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.32621",
  "orders-card-lib": "/orders-card-lib/static-1.17329",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.15617",
  "recording-preview-card": "/recording-preview-card/static-1.12695",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.36136",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.27640",
  "sales-execution-components": "/sales-execution-components/static-1.9059",
  "process-guide-chirp": "/process-guide-chirp/static-1.3833",
  "gapi-client-types": "/gapi-client-types/static-1.5",
  "google-picker-types": "/google-picker-types/static-1.5",
  "ui-google-drive-commons": "/ui-google-drive-commons/static-1.663",
  "ui-google-drive-picker": "/ui-google-drive-picker/static-1.2098",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.12238",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.14831",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.4731",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.4847",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.3679",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.15532",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.12503",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.12499",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.5095",
  "automation-ui-routing": "/automation-ui-routing/static-1.15994",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.13716",
  "immerable": "/immerable/static-1.3045",
  "social-insights-client-types": "/social-insights-client-types/static-1.18063",
  "user-configuration-lib": "/user-configuration-lib/static-1.25577",
  "tinymce-themes": "/tinymce-themes/static-1.52157",
  "interframe": "/interframe/static-3.3688",
  "tinymce-data": "/tinymce-data/static-1.36272",
  "tinymce-plugins": "/tinymce-plugins/static-1.53301",
  "ContentData": "/ContentData/static-1.63772",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1464",
  "sales-views-client-types": "/sales-views-client-types/static-1.3212",
  "ui-signature-editor": "/ui-signature-editor/static-1.14200",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9096",
  "stripe-connect-js": "/stripe-connect-js/static-1.40",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.16036",
  "form-builder-ui": "/form-builder-ui/static-1.8010",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.15957",
  "ai-rendering-library": "/ai-rendering-library/static-1.5591",
  "calendar-integration-client-types": "/calendar-integration-client-types/static-1.2628",
  "calendar-integration-events-lib": "/calendar-integration-events-lib/static-1.4698",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5309",
  "react-window": "/react-window/static-1.13",
  "ai-studio-lib": "/ai-studio-lib/static-1.6291",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.10520",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.14790",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.9005",
  "app-users-service-client": "/app-users-service-client/static-1.4078",
  "app-users-service-types": "/app-users-service-types/static-1.3486",
  "framework-listing-lib": "/framework-listing-lib/static-2.23281",
  "mini-checkout-client": "/mini-checkout-client/static-1.24466",
  "onboarding-utils": "/onboarding-utils/static-1.4251",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.23500",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8303",
  "layout-dnd-components": "/layout-dnd-components/static-1.10831",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9806",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.9282",
  "apps-service-types": "/apps-service-types/static-1.2980",
  "oauth-service-types": "/oauth-service-types/static-1.3193",
  "automation-ui-types": "/automation-ui-types/static-1.14634",
  "highlight.js": "/highlight.js/static-1.45",
  "automation-ui-action-features": "/automation-ui-action-features/static-1.50313",
  "academy-common-lib": "/academy-common-lib/static-1.9980",
  "customer-data-views-management": "/customer-data-views-management/static-1.22571",
  "touchless-buying-components": "/touchless-buying-components/static-1.3502",
  "merchandise-lib": "/merchandise-lib/static-1.223",
  "settings-content-modals": "/settings-content-modals/static-1.40892",
  "layout-data-lib": "/layout-data-lib/static-1.8131",
  "ads-client-types": "/ads-client-types/static-1.17574",
  "automation-actions-service-types": "/automation-actions-service-types/static-1.3388",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2622",
  "automation-ui-action-fields": "/automation-ui-action-fields/static-1.33690",
  "automation-ui-associations": "/automation-ui-associations/static-1.15244",
  "automation-ui-enrollment": "/automation-ui-enrollment/static-1.51975",
  "automation-ui-flow-core": "/automation-ui-flow-core/static-1.15959",
  "automation-ui-formula-editor": "/automation-ui-formula-editor/static-1.12076",
  "automation-ui-i18n": "/automation-ui-i18n/static-1.16027",
  "automation-ui-references": "/automation-ui-references/static-1.15982",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.4565",
  "data-token-views": "/data-token-views/static-1.14245",
  "fuzzy": "/fuzzy/static-1.8",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.41233",
  "skills-lib": "/skills-lib/static-1.25493",
  "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12467",
  "academy-service-client": "/academy-service-client/static-1.2688",
  "crm-export-dialog": "/crm-export-dialog/static-1.5185",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "checkout-sdk": "/checkout-sdk/static-3.21309",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.8427",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2711",
  "access-control-lib": "/access-control-lib/static-1.9351",
  "EmailComponents": "/EmailComponents/static-1.49786",
  "EmailData": "/EmailData/static-1.48462",
  "redux-less": "/redux-less/static-2.8348",
  "crm-association-components-lib": "/crm-association-components-lib/static-1.5322",
  "messaging-publishing-lib": "/messaging-publishing-lib/static-1.41185",
  "mobile-messaging-management-lib": "/mobile-messaging-management-lib/static-1.29904",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.4227",
  "workflows-copilot-service-types": "/workflows-copilot-service-types/static-1.1562",
  "ContentEditorUI": "/ContentEditorUI/static-2.72328",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2974",
  "ui-tool-access": "/ui-tool-access/static-1.8969",
  "web-interactives-components": "/web-interactives-components/static-1.11659",
  "web-interactives-data": "/web-interactives-data/static-1.11660",
  "conversations-thread-view": "/conversations-thread-view/static-1.72060",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4663",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.619",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "pricing-pages-api": "/pricing-pages-api/static-1.8289",
  "ContentComponents": "/ContentComponents/static-2.66653",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.8041",
  "messaging-management-lib": "/messaging-management-lib/static-1.12745",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3977",
  "copilot-plugins": "/copilot-plugins/static-1.6817",
  "cta-picker": "/cta-picker/static-1.32084",
  "editor-components": "/editor-components/static-1.11922",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.7215",
  "error-messaging-js": "/error-messaging-js/static-1.4194",
  "pictos": "/pictos/static-7.161",
  "redux-request-state": "/redux-request-state/static-1.9488",
  "smart-content-core": "/smart-content-core/static-1.37950",
  "smart-content-lib": "/smart-content-lib/static-1.38603",
  "social-composer-lib": "/social-composer-lib/static-1.53880",
  "structured-content-lib": "/structured-content-lib/static-1.20848",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.48706",
  "tinymce-copilot": "/tinymce-copilot/static-1.12255",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.32891",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.29116",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6120",
  "calling-integration-help-desk": "/calling-integration-help-desk/static-1.20045",
  "demographics-service-types": "/demographics-service-types/static-1.748",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2280",
  "personalization-service-types": "/personalization-service-types/static-1.2101",
  "trials-service-types": "/trials-service-types/static-1.2999",
  "simple-menus-core": "/simple-menus-core/static-1.13674",
  "simple-menus-lib": "/simple-menus-lib/static-1.15191",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.5077",
  "jquery": "/jquery/static-3.6",
  "codemirror-dlb": "/codemirror-dlb/static-1.53884",
  "redux-undo": "/redux-undo/static-1.10",
  "seamless-immutable": "/seamless-immutable/static-7.6"
}
};
